import React, { useState } from 'react';
import { Button, Paper, Typography, Box, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HttpHelper from '../../utils/HttpHelper';
import { isStringEmpty } from '../../utils/formValidation';

interface AssessmentState {
    title: string;
    description: string;
    isOptional: boolean;
}



const CreateAssessment: React.FC = () => {
    const [assessment, setAssessment] = useState<AssessmentState>({
        title: '',
        description: '',
        isOptional: false,
    });

    const CREATE_ASSESSMENT_ENDPOINT: string = "assessments/create";
    const [titleFieldEmpty, setTitleFieldEmpty] = useState<boolean>(false);
    const [descriptionFieldEmpty, setDescriptionFieldEmpty] = useState<boolean>(false);

    const navigate = useNavigate();



    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const isTitleEmpty = isStringEmpty(assessment.title);
        const isDescriptionEmpty = isStringEmpty(assessment.description);
        setTitleFieldEmpty(isTitleEmpty);
        setDescriptionFieldEmpty(isDescriptionEmpty);

        if (isTitleEmpty || isDescriptionEmpty) {
            console.error("Title or description is empty.");
            return;
        } try {
            const assessmentData = {
                assessment: {
                    title: assessment.title,
                    description: assessment.description,
                    isOptional: assessment.isOptional,
                },
            };

            const responseData = await HttpHelper.post(CREATE_ASSESSMENT_ENDPOINT, assessmentData);

            if (responseData && responseData.assessmentId) {
                console.log(responseData.assessmentId);
                navigate(`/manage-assessments/addQuestions/${responseData.assessmentId}`);
            } else {
                console.error("Unexpected response structure:", responseData);
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
        }

    };


    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAssessment(prevAssessment => ({
            ...prevAssessment,
            title: event.target.value,
        }));
    };

    const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAssessment(prevAssessment => ({
            ...prevAssessment,
            description: event.target.value,
        }));
    };

    const handleOptionalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAssessment(prevAssessment => ({
            ...prevAssessment,
            isOptional: event.target.checked,
        }));
    };

    return (
        <Paper sx={{
            padding: '2rem', margin: '2rem', width: '100%', marginLeft: 'auto', marginRight: 'auto',
        }} component="form" onSubmit={handleSubmit}>
            <Typography variant="h5" fontWeight="bold">Create a New Assessment</Typography>
            <Box sx={{ marginBottom: '1rem', marginTop: '2rem' }}>
                <TextField
                    fullWidth
                    label="Assessment Title"
                    variant="outlined"
                    value={assessment.title}
                    error={titleFieldEmpty}
                    onChange={handleTitleChange}
                />
            </Box>
            <Box sx={{ marginBottom: '1rem' }}>
                <TextField
                    fullWidth
                    label="Assessment Description"
                    variant="outlined"
                    multiline
                    rows={4}
                    value={assessment.description}
                    error={descriptionFieldEmpty}
                    onChange={handleDescriptionChange}
                />
            </Box>
            <Box>
                <FormControlLabel
                    sx={{ ml: 0 }} // remove default negative left margin
                    control={<Checkbox checked={assessment.isOptional} onChange={handleOptionalChange} />}
                    label="Optional Assessment"
                />
            </Box>

            <Button
                type="submit"
                variant="contained"
                sx={{
                    backgroundColor: 'var(--ttg-green)',
                    '&:hover': {
                        backgroundColor: 'var(--button-hover-green)',
                    },
                    marginTop: 3,
                    marginBottom: 3,
                }}
            >
                Next
            </Button>
        </Paper>
    );
};

export default CreateAssessment;
